/* Баннер отдела электроники: сцены ZOZOZON, «Популярное» и «Скидки».
 *
 * Замысел владельца 14.10.2026 (после нескольких проб на живой копии темы):
 *   • «в начале… баннер, где написано, сколько товаров… и кнопка Öffnen →»;
 *   • «потом меняется на Aktuelle Angebote — не надо, чтоб долго двигалась: стартует,
 *      сдвигается на 1/4 или 2/4 и остановилась; потом опять наша реклама ZOZOZON, потом
 *      иные товары, можно без движения, но двигать самому мышкой»;
 *   • «товар крупнее, текста меньше, цена и картинка важна»;
 *   • «коллекция не повторяющаяся… только не outlet»;
 *   • «в рекламу что-то потребительское, что спросом пользуется» (данные /spros/acc);
 *   • «адаптироваться под грядущие праздники… чёрную пятницу или иной event».
 *
 * Порядок: ZOZOZON → Популярное → ZOZOZON → Скидки → ZOZOZON → Популярное … Каждая
 * сцена товаров — следующие 6 товаров своего списка (списки перемешаны при заходе),
 * так что повторы начинаются, только когда список кончился.
 *   ZOZOZON — уже стоит в разметке страницы (Liquid): пустоты при загрузке нет.
 *   товары  — 4 на экране; каждая вторая такая сцена один раз плавно разгоняется,
 *             сдвигается на два товара и встаёт; остальные стоят. Толкать можно всегда.
 *   смена   — старая сцена гаснет, рассыпаясь на пиксели; новая собирается из них.
 * Уступает выбору плиток (мышь над плиткой — замирает и бледнеет). Кнопка ⏸ (WCAG
 * 2.2.2) останавливает цикл и помнится.
 *
 * Цена, скидка, наличие и название ПЕРЕПРОВЕРЯЮТСЯ у Shopify (Storefront магазина, без
 * ключа, в валюте и на языке покупателя). «Популярное» — спрос у поставщика ACC (уход
 * его остатка), не наши продажи: потому и слово «популярное», а не «у нас покупают».
 * Ни одного обращения к нашему серверу.
 */
(function () {
  'use strict';

  // времена в секундах
  var BREND = 7, TOVARY = 8, PERED_SDVIGOM = 1.5, SDVIG = 3, RASPAD = 1.8, SBORKA = 1.1;
  var NA_EKRANE = 4, V_SCENE = 6, SDVIG_KART = 2;
  var PIKSEL = 22, SPOKOJNO = 4, OZHIT = 1;

  var SLOVA = {
    en: { pop: 'Popular now', sk: 'Deals right now', stop: 'Pause', idti: 'Play', cherez: 'in {n} days', zavtra: 'tomorrow',
          b1: '{n} electronics products · {b} brands', b2: 'Prices in your currency, taxes included',
          bf: 'Black Friday', bfsk: 'Black Friday deals', xmas: 'Christmas gifts', val: "Valentine's Day gifts", school: 'Back to school' },
    de: { pop: 'Beliebt', sk: 'Aktuelle Angebote', stop: 'Anhalten', idti: 'Abspielen', cherez: 'in {n} Tagen', zavtra: 'morgen',
          b1: '{n} Elektronikprodukte · {b} Marken', b2: 'Preise in Ihrer Währung, inklusive Steuern',
          bf: 'Black Friday', bfsk: 'Black-Friday-Angebote', xmas: 'Weihnachtsgeschenke', val: 'Geschenke zum Valentinstag', school: 'Zurück zur Schule' },
    fr: { pop: 'Populaire', sk: 'Promotions du moment', stop: 'Pause', idti: 'Lecture', cherez: 'dans {n} jours', zavtra: 'demain',
          b1: '{n} produits électroniques · {b} marques', b2: 'Prix dans votre devise, taxes comprises',
          bf: 'Black Friday', bfsk: 'Offres Black Friday', xmas: 'Cadeaux de Noël', val: 'Cadeaux de Saint-Valentin', school: 'Rentrée scolaire' },
    nl: { pop: 'Populair', sk: 'Nu in de aanbieding', stop: 'Pauzeren', idti: 'Afspelen', cherez: 'over {n} dagen', zavtra: 'morgen',
          b1: '{n} elektronicaproducten · {b} merken', b2: 'Prijzen in uw valuta, inclusief belastingen',
          bf: 'Black Friday', bfsk: 'Black Friday-deals', xmas: 'Kerstcadeaus', val: 'Valentijnscadeaus', school: 'Terug naar school' },
    no: { pop: 'Populært', sk: 'Tilbud akkurat nå', stop: 'Pause', idti: 'Spill av', cherez: 'om {n} dager', zavtra: 'i morgen',
          b1: '{n} elektronikkprodukter · {b} merker', b2: 'Priser i din valuta, inkludert avgifter',
          bf: 'Black Friday', bfsk: 'Black Friday-tilbud', xmas: 'Julegaver', val: 'Valentinsgaver', school: 'Tilbake til skolen' },
    et: { pop: 'Populaarne', sk: 'Praegused pakkumised', stop: 'Peata', idti: 'Mängi', cherez: '{n} päeva pärast', zavtra: 'homme',
          b1: '{n} elektroonikatoodet · {b} brändi', b2: 'Hinnad teie valuutas, koos maksudega',
          bf: 'Black Friday', bfsk: 'Black Friday pakkumised', xmas: 'Jõulukingid', val: 'Sõbrapäeva kingid', school: 'Tagasi kooli' },
    es: { pop: 'Lo más popular', sk: 'Ofertas ahora', stop: 'Pausa', idti: 'Reproducir', cherez: 'en {n} días', zavtra: 'mañana',
          b1: '{n} productos de electrónica · {b} marcas', b2: 'Precios en tu moneda, impuestos incluidos',
          bf: 'Black Friday', bfsk: 'Ofertas Black Friday', xmas: 'Regalos de Navidad', val: 'Regalos de San Valentín', school: 'Vuelta al cole' },
    fi: { pop: 'Suosittua nyt', sk: 'Tarjoukset nyt', stop: 'Pysäytä', idti: 'Toista', cherez: '{n} päivän päästä', zavtra: 'huomenna',
          b1: '{n} elektroniikkatuotetta · {b} merkkiä', b2: 'Hinnat omassa valuutassasi, verot sisältyvät',
          bf: 'Black Friday', bfsk: 'Black Friday -tarjoukset', xmas: 'Joululahjat', val: 'Ystävänpäivän lahjat', school: 'Takaisin kouluun' },
    ru: { pop: 'Популярное', sk: 'Скидки сейчас', stop: 'Остановить', idti: 'Запустить', cherez: 'через {n} дн.', zavtra: 'завтра',
          b1: '{n} товаров электроники · брендов: {b}', b2: 'Цены в вашей валюте, налоги включены',
          bf: 'Black Friday', bfsk: 'Скидки Black Friday', xmas: 'Подарки к Рождеству', val: 'Подарки ко Дню святого Валентина', school: 'Снова в школу' }
  };
  var E = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };

  /* --- события календаря ----------------------------------------------------
     Возвращает { metka, skidki? } или null. Даты настоящие: отсчёт до Black
     Friday — правда, а не «осталось 2 часа». «Скидки Black Friday» называются
     так только в сам период и только на сцене реальных скидок.
     Своё событие из редактора темы (текст + даты) главнее календаря.
     Для проверки: ?zz_data=2026-11-20 в адресе подменяет сегодняшнюю дату. */
  function sobytie(T, o) {
    var q = /[?&]zz_data=(\d{4}-\d{2}-\d{2})/.exec(location.search);
    var seg = q ? new Date(q[1] + 'T12:00:00') : new Date();
    seg = new Date(seg.getFullYear(), seg.getMonth(), seg.getDate());
    var g = seg.getFullYear();
    var den = function (m, d) { return new Date(g, m - 1, d); };
    var dney = function (a) { return Math.round((a - seg) / 864e5); };
    var data = function (a) {
      try { return a.toLocaleDateString(o.lang, { day: 'numeric', month: 'numeric' }); } catch (e) { return a.getDate() + '.' + (a.getMonth() + 1); }
    };
    if (o.sobytie && o.sobytie.text && o.sobytie.s && o.sobytie.po) {
      var s = new Date(o.sobytie.s + 'T00:00:00'), p = new Date(o.sobytie.po + 'T23:59:59');
      if (seg >= new Date(s.getFullYear(), s.getMonth(), s.getDate()) && seg <= p) return { metka: o.sobytie.text, skidki: o.sobytie.text };
    }
    // Black Friday — пятница после четвёртого четверга ноября
    var nov1 = den(11, 1), chet = (11 - nov1.getDay()) % 7 + 1 + 21;   // 4-й четверг
    var bf = den(11, chet + 1), cm = den(11, chet + 4);                // Cyber Monday
    if (seg >= bf && seg <= cm) return { metka: T.bf, skidki: T.bfsk, goryachee: true };
    if (seg >= nov1 && seg < bf) {
      var n = dney(bf);
      return { metka: T.bf + ' · ' + data(bf) + ' · ' + (n === 1 ? T.zavtra : T.cherez.replace('{n}', n)) };
    }
    if (seg > cm && seg <= den(12, 24)) return { metka: T.xmas };
    if (seg >= den(2, 1) && seg <= den(2, 14)) return { metka: T.val };
    if (seg >= den(8, 15) && seg <= den(9, 15)) return { metka: T.school };
    return null;
  }

  /* el — блок баннера; в нём уже стоит сцена ZOZOZON из разметки (Liquid).
     o: lang, sfLang, country, sfApi, base, sobytie {text, s, po} */
  window.zzOtdelAkcii = function (el, url, o) {
    if (!el) return;
    var T = SLOVA[o.lang] || SLOVA.en;
    var chislo = function (n) { try { return n.toLocaleString(o.lang); } catch (e) { return String(n); } };
    var fmt = function (minor, cur) {
      try { return new Intl.NumberFormat(o.lang, { style: 'currency', currency: cur, maximumFractionDigits: 2 }).format(minor / 100); }
      catch (e) { return (minor / 100).toFixed(2) + ' ' + cur; }
    };
    var ev = sobytie(T, o);
    if (ev) {                                             // метка события — в сцену бренда сразу
      var m = el.querySelector('.zz-ak-sob');
      if (m) { m.textContent = ev.metka; m.hidden = false; if (ev.goryachee) m.classList.add('gor'); }
    }
    fetch(url, { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j) return null;
        if (j.brend && j.brend.tovarov) {
          var t1 = el.querySelector('.zz-ak-b1'), t2 = el.querySelector('.zz-ak-b2');
          if (t1) t1.textContent = T.b1.replace('{n}', chislo(j.brend.tovarov)).replace('{b}', chislo(j.brend.brendov));
          if (t2) t2.textContent = T.b2;
        }
        var sk = (j.tovary || []).map(function (t) { return { h: t.h, img: t.img, vid: 'sk' }; });
        var pop = (j.populyarnye || []).map(function (t) { return { h: t.h, img: t.img, vid: 'pop' }; });
        var vse = sk.concat(pop);
        if (!vse.length) return null;
        var ctx = [];
        if (o.country) ctx.push('country:' + o.country);
        if (o.sfLang) ctx.push('language:' + o.sfLang);
        var q = 'query' + (ctx.length ? ' @inContext(' + ctx.join(',') + ')' : '') + '{' +
          vse.map(function (t, i) {
            return 'p' + i + ':product(handle:' + JSON.stringify(t.h) + '){title availableForSale ' +
                   'priceRange{minVariantPrice{amount currencyCode}} compareAtPriceRange{maxVariantPrice{amount}}}';
          }).join(' ') + '}';
        return fetch(o.sfApi, { method: 'POST', credentials: 'omit',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({ query: q }) })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            var data = (res && res.data) || {}, out = { sk: [], pop: [] };
            vse.forEach(function (t, i) {
              var x = data['p' + i];
              if (!x || !x.availableForSale) return;
              var mp = x.priceRange.minVariantPrice, ca = x.compareAtPriceRange.maxVariantPrice;
              var p = Math.round(parseFloat(mp.amount) * 100), c = ca ? Math.round(parseFloat(ca.amount) * 100) : 0;
              var est = c > p && p > 0;
              if (t.vid === 'sk' && !est) return;                // скидки больше нет
              out[t.vid].push({ h: t.h, img: t.img, t: x.title, p: p, c: est ? c : 0, cur: mp.currencyCode,
                                d: est ? Math.round((c - p) / c * 100) : 0 });
            });
            return out;
          });
      })
      .then(function (z) { if (z && (z.sk.length >= NA_EKRANE || z.pop.length >= NA_EKRANE)) sobrat(el, z, T, fmt, o, ev); })
      .catch(function () { /* остаётся сцена ZOZOZON из разметки */ });
  };

  var peremeshat = function (a) {
    for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)), x = a[i]; a[i] = a[j]; a[j] = x; }
    return a;
  };

  function sobrat(el, z, T, fmt, o, ev) {
    var img = function (u, w) { return u.replace(/(\.\w+)(\?.*)?$/, '_' + w + 'x$1'); };
    // карточка: крупная картинка и цена; название одной строкой, мелко
    var karta = function (x) {
      return '<a class=zz-ak-kart href="' + E(o.base + x.h) + '" title="' + E(x.t) + '">' +
             (x.d ? '<span class=zz-ak-skidka>−' + x.d + ' %</span>' : '') +
             '<img src="' + E(img(x.img, 300)) + '" alt="' + E(x.t) + '" loading=lazy>' +
             '<span class=zz-ak-ceny><b>' + E(fmt(x.p, x.cur)) + '</b>' + (x.c ? ' <s>' + E(fmt(x.c, x.cur)) + '</s>' : '') + '</span>' +
             '<span class=zz-ak-t>' + E(x.t) + '</span></a>';
    };
    // сцены по V_SCENE товаров из перемешанных списков; хвост меньше 4 — к предыдущей
    var nareza = function (spisok) {
      var g = [];
      for (var i = 0; i < spisok.length; i += V_SCENE) g.push(spisok.slice(i, i + V_SCENE));
      if (g.length > 1 && g[g.length - 1].length < NA_EKRANE) g[g.length - 2] = g[g.length - 2].concat(g.pop());
      return g.filter(function (x) { return x.length >= NA_EKRANE; });
    };
    var golovaSk = ev && ev.skidki ? ev.skidki : T.sk;
    var scena = function (g, golova) {
      var k = g.map(karta).join('');
      return '<div class="zz-ak-scena zz-ak-tovary"><div class=zz-ak-head>' + E(golova) + '</div>' +
             '<div class=zz-ak-lenta>' + k + k.replace(/<a /g, '<a aria-hidden=true tabindex=-1 ') + '</div></div>';
    };
    var vsePop = z.pop.slice();
    var pop = nareza(peremeshat(z.pop)).map(function (g) { return scena(g, T.pop); });
    var sk = nareza(peremeshat(z.sk)).map(function (g) { return scena(g, golovaSk); });
    // чередовать: популярное, скидки, популярное, … (в Black Friday — скидки первыми)
    var tovary = [], a = (ev && ev.skidki) ? sk : pop, b = (ev && ev.skidki) ? pop : sk;
    for (var i = 0; i < Math.max(a.length, b.length); i++) {
      if (a[i]) tovary.push(a[i]);
      if (b[i]) tovary.push(b[i]);
    }
    if (!tovary.length) return;
    var brend = el.querySelector('.zz-ak-brend');
    var okno = document.createElement('div');
    okno.className = 'zz-ak-okno';
    okno.innerHTML = tovary.join('') + '<div class=zz-ak-pix aria-hidden=true></div>';
    brend.classList.add('zz-ak-scena', 'act');
    okno.insertBefore(brend, okno.firstChild);
    el.innerHTML = '';
    el.className = 'zz-banner zz-akcii';
    el.appendChild(okno);
    var kn = document.createElement('button');
    kn.type = 'button'; kn.className = 'zz-ak-pauza'; kn.textContent = '⏸';
    el.appendChild(kn);
    // нижнюю строку «Весь отдел» не показываем: кнопка «Открыть» есть в сцене ZOZOZON
    // (владелец 14.10.2026: «этот блок не дублирует?»). Она нужна, только когда в редакторе
    // стоит своя картинка-баннер, — это решает разметка страницы.
    // мозаика сцены ZOZOZON: картинки популярного (и скидок, если популярного мало), без цен
    var mozPul = peremeshat(vsePop.concat(z.sk)).map(function (x) { return img(x.img, 160); });
    zhit(el, okno, kn, T, mozPul);
  }

  function zhit(el, okno, kn, T, mozPul) {
    var tovary = Array.prototype.slice.call(okno.querySelectorAll('.zz-ak-tovary'));
    var brend = okno.querySelector('.zz-ak-brend');
    var pix = okno.querySelector('.zz-ak-pix'), kletki = [];
    // сдвиг — через сцену: товары со сдвигом, бренд, товары без движения, бренд, снова со сдвигом
    // (владелец 14.10.2026: «прокат был удачный: ускорение и остановка… потом новые товары без
    //  прокрутки, потом баннер, потом товары уже опять с прокруткой такой же»)
    var tek = brend, nTov = -1, pokazov = 0, sdvigNado = false, sdvigBylo = false;
    var x = 0, v = 0, polovina = 0, shirKart = 0, nad = false, tyanem = false;
    var px0 = 0, x0 = 0, sdvig = 0, tPred = 0, xPred = 0, t = 0;
    var faza = 'stoit', vFazy = 0, cel = 0, start = 0;
    var tiho = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var lenta = function () { return tek.querySelector('.zz-ak-lenta'); };

    // ширина карточки — четверть окна: на экране ровно 4 товара (на телефоне — полтора)
    var zamer = function () {
      var w = okno.getBoundingClientRect().width || 1000;
      shirKart = w < 700 ? w / 1.5 : w / NA_EKRANE;
      okno.style.setProperty('--zz-kart', shirKart.toFixed(1) + 'px');
      var l = lenta(); polovina = l ? l.scrollWidth / 2 : 0;
    };
    var obernut = function () {
      if (!polovina) return;
      while (x <= -polovina) x += polovina;
      while (x > 0) x -= polovina;
    };
    var setka = function () {
      var r = okno.getBoundingClientRect();
      var kol = Math.max(8, Math.ceil((r.width || 1000) / PIKSEL)), str = Math.max(4, Math.ceil((r.height || 220) / PIKSEL));
      pix.style.gridTemplateColumns = 'repeat(' + kol + ',1fr)';
      pix.style.gridTemplateRows = 'repeat(' + str + ',1fr)';
      var h = [];
      for (var n = 0; n < kol * str; n++) h.push('<i style="background:hsl(215,20%,' + (93 + Math.floor(Math.random() * 7)) + '%)"></i>');
      pix.innerHTML = h.join('');
      kletki = Array.prototype.slice.call(pix.children);
    };
    var vrazbros = function (vkl, dlit) {
      kletki.forEach(function (k) {
        k.style.transitionDelay = (Math.random() * dlit * 0.7).toFixed(3) + 's';
        k.classList.toggle('on', vkl);
      });
    };
    // мозаика: при каждом показе сцены бренда — следующие 6 картинок пула, по очереди проявляются
    var moz = brend.querySelector('.zz-ak-mozaika'), mozI = 0;
    var mozaika = function () {
      if (!moz || !mozPul || !mozPul.length) return;
      var h = [];
      for (var n = 0; n < 6; n++) {
        h.push('<img src="' + E(mozPul[mozI % mozPul.length]) + '" alt="" style="animation-delay:' + (n * 0.18).toFixed(2) + 's">');
        mozI++;
      }
      moz.innerHTML = h.join('');
    };
    mozaika();
    zamer(); setka();
    window.addEventListener('resize', function () { zamer(); setka(); });
    okno.style.touchAction = 'pan-y';

    // кнопка паузы, выбор помнится
    var stoit = false;
    try { stoit = window.localStorage.getItem('zz-lenta-stoit') === '1'; } catch (e) {}
    var risovat = function () {
      kn.textContent = stoit ? '▶' : '⏸';
      kn.setAttribute('aria-pressed', stoit ? 'true' : 'false');
      kn.title = stoit ? T.idti : T.stop; kn.setAttribute('aria-label', kn.title);
    };
    kn.addEventListener('click', function () {
      stoit = !stoit; v = 0; risovat();
      try { window.localStorage.setItem('zz-lenta-stoit', stoit ? '1' : '0'); } catch (e) {}
    });
    risovat();

    // уступать внимание выбору плиток
    var vybor = false, tVybora = 0, tStart = performance.now();
    el.addEventListener('mouseenter', function () { nad = true; });
    el.addEventListener('mouseleave', function () { nad = false; });
    Array.prototype.forEach.call(document.querySelectorAll('.zz-plitka'), function (p) {
      p.addEventListener('mouseenter', function () { vybor = true; el.classList.add('zz-tiho'); });
      p.addEventListener('mouseleave', function () { vybor = false; tVybora = performance.now(); el.classList.remove('zz-tiho'); });
    });

    // толкать мышью и пальцем (сцены товаров); захват — когда это уже перетаскивание
    okno.addEventListener('pointerdown', function (e) {
      if (faza === 'raspad' || faza === 'sborka' || !lenta()) return;
      tyanem = true; sdvig = 0; px0 = e.clientX; x0 = x; v = 0; xPred = x; tPred = performance.now();
      okno.classList.add('tyanem');
    });
    okno.addEventListener('pointermove', function (e) {
      if (!tyanem) return;
      var dx = e.clientX - px0, bylo = sdvig; sdvig = Math.max(sdvig, Math.abs(dx));
      if (bylo <= 6 && sdvig > 6 && okno.setPointerCapture) { try { okno.setPointerCapture(e.pointerId); } catch (er) {} }
      x = x0 + dx; obernut();
      var tn = performance.now();
      if (tn - tPred > 16) { v = (x - xPred) / ((tn - tPred) / 1000); xPred = x; tPred = tn; }
    });
    var otpustit = function () {
      if (!tyanem) return;
      tyanem = false; v *= 1.4; okno.classList.remove('tyanem');
      if (sdvig > 6) { faza = 'stoit'; vFazy = 0; }           // человек смотрит — сцена стоит заново
    };
    okno.addEventListener('pointerup', otpustit);
    okno.addEventListener('pointercancel', otpustit);
    okno.addEventListener('click', function (e) { if (sdvig > 6) { e.preventDefault(); e.stopPropagation(); } }, true);
    okno.addEventListener('dragstart', function (e) { e.preventDefault(); });
    okno.addEventListener('wheel', function (e) {
      if (lenta() && Math.abs(e.deltaX) > Math.abs(e.deltaY)) { x -= e.deltaX; obernut(); v = 0; e.preventDefault(); }
    }, { passive: false });

    // следующая сцена: после бренда — очередные товары, после товаров — бренд
    var podmenit = function () {
      tek.classList.remove('act', 'tayet');
      if (tek === brend) {
        nTov = (nTov + 1) % tovary.length; tek = tovary[nTov];
        pokazov++; sdvigNado = pokazov % 2 === 1; sdvigBylo = false;
      } else { tek = brend; mozaika(); }
      tek.classList.add('act');
      x = 0; v = 0;
      if (lenta()) lenta().style.transform = 'translate3d(0,0,0)';
      zamer();
    };
    var dlitStoit = function () {
      if (tek === brend) return BREND;
      return (sdvigNado && !sdvigBylo && !tiho) ? PERED_SDVIGOM : TOVARY;
    };
    var plavno = function (k) { return k < 0.5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2; };

    var kadr = function (tn) {
      var dt = t ? Math.min(0.05, (tn - t) / 1000) : 0; t = tn;
      var zhivet = !nad && !stoit && !document.hidden && !vybor &&
                   tn - tStart > SPOKOJNO * 1000 && tn - tVybora > OZHIT * 1000;
      if (!tyanem) {
        if (Math.abs(v) > 5) { x += v * dt; v *= Math.pow(0.15, dt); obernut(); }   // толчок, инерция ~2 с
        else if (zhivet || faza === 'raspad' || faza === 'sborka' || faza === 'sdvig') {
          vFazy += dt;
          if (faza === 'stoit') {
            if (vFazy >= dlitStoit()) {
              if (tek !== brend && sdvigNado && !sdvigBylo && !tiho) {   // сдвиг — в каждой второй сцене товаров
                faza = 'sdvig'; vFazy = 0; start = x; cel = x - SDVIG_KART * shirKart; sdvigBylo = true;
              } else {
                faza = 'raspad'; vFazy = 0; tek.classList.add('tayet'); if (!tiho) vrazbros(true, RASPAD);
              }
            }
          } else if (faza === 'sdvig') {
            var k = Math.min(1, vFazy / SDVIG);
            x = start + (cel - start) * plavno(k);
            if (k >= 1) { faza = 'stoit'; vFazy = 0; }
          } else if (faza === 'raspad') {
            if (vFazy >= (tiho ? 0.3 : RASPAD)) { podmenit(); faza = 'sborka'; vFazy = 0; if (!tiho) vrazbros(false, SBORKA); }
          } else if (faza === 'sborka') {
            if (vFazy >= (tiho ? 0.3 : SBORKA)) { faza = 'stoit'; vFazy = 0; }
          }
        }
      }
      if (lenta()) lenta().style.transform = 'translate3d(' + x.toFixed(1) + 'px,0,0)';
      requestAnimationFrame(kadr);
    };
    requestAnimationFrame(kadr);
  }
})();
